import type { Catalog } from "./types.js";

const accents: Record<string, string> = {
  a: "á", e: "ë", i: "ï", o: "ö", u: "ü", A: "Á", E: "Ë", I: "Ï", O: "Ö", U: "Ü",
};
const protectedText = /(\{\{[^}]+\}\}|<[^>]+>|https?:\/\/[^\s<>]+|\/[a-z][a-z0-9_]*|--[a-z][a-z0-9-]*|\b(?:Chatcode|Claude Code|Claude|Codex|Gemini|Antigravity|Kimi|Pi|OpenCode|tmux|Basic|Starter|Plus|Pro)\b)/g;

export function pseudoLocalize(value: string): string {
  let expandedLength = 0;
  const translated = value.split(protectedText).map((part, index) => {
    if (index % 2) return part;
    expandedLength += part.length;
    return part.replace(/[aeiouAEIOU]/g, (letter) => accents[letter]);
  }).join("");
  return `⟦${translated}${"·".repeat(Math.ceil(expandedLength * 0.4))}⟧`;
}

export function pseudoCatalog(catalog: Catalog): Record<string, string> {
  // The badge next to the brand is invariant, including in the test locale.
  return Object.fromEntries(Object.entries(catalog).map(([key, value]) => [key, key === "beta" ? value : pseudoLocalize(value)]));
}
